import { t } from "../i18n";

export function InactiveScreen() {
  return (
    <div
      className="panel-body"
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 1 }}
    >
      <div style={{ textAlign: 'center', padding: '2rem', color: '#6b7280' }}>
        <svg
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#9ca3af"
          strokeWidth={1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ margin: '0 auto 1rem', display: 'block' }}
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
        </svg>
        <p style={{ fontSize: '1rem', fontWeight: 600, margin: '0 0 0.5rem' }}>
          {t('widgetUnavailable')}
        </p>
        <p style={{ fontSize: '0.85rem', margin: 0 }}>{t('widgetUnavailableDesc')}</p>
      </div>
    </div>
  );
}
